import { Box, Typography, TextField } from "@mui/material";

type TextFieldWithErrorProps = {
    value: string;
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name: string;
    label: string;
    size: "small" | "medium";
    inputRef?: React.RefObject<HTMLInputElement>;
    errorMsg?: string;
    sx?: any;
};

export const TextFieldWithError = ({
    value,
    inputRef,
    handleChange,
    name,
    label,
    size,
    errorMsg,
    sx,
}: TextFieldWithErrorProps) => {
    const styles = {
        formField: {
            flex: 1,
        },
        textFieldWrapper: {
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minWidth: "250px",
        },
        error: {
            color: "red",
            fontSize: "0.75rem",
            mt: ".15rem",
            flex: 1,
        },
    };
    return (
        <Box sx={styles.textFieldWrapper}>
            <TextField
                sx={styles.formField}
                value={value}
                onChange={handleChange}
                name={name}
                label={label}
                size={size}
                inputRef={inputRef}
            />
            {errorMsg && <Typography sx={styles.error}>{errorMsg}</Typography>}
        </Box>
    );
};
